
import configs from '@/configs.js';
import {login,getUserWhiteNavs,getUserAuthedWhiteNavs,logout} from "@/utils/utils";
import { getUserTheme,rolesByUser} from '@/api/user';
import store from "@/store";
import {Message} from "portal-component";
import userThemes from '@/utils/handleUserThemes';
let getRoleAndNavigation = async()=> {


    let res = null
    // 获取用户主题与导航栏信息
    try{
      res = await getUserTheme();
    }catch(e){
      store.commit("SET_SYSTEM_STATUS",'Error');
      return false
    }

    if(res && res.code === 0) {
      // 接口请求成功，系统状态改为正常状态
      store.commit("SET_SYSTEM_STATUS",'');
      let allThemes = res.data || [];
      if(allThemes.length === 0) {
        // 无主题,清除本地储存的主题信息
        store.commit("SET_USER_THEME_CONFIG",null);
        store.commit("SET_SYSTEM_STATUS",'SystemUpdating');
        return ;
      }
      let selectedTheme = userThemes.getSelectedUserTheme(allThemes);
      let pageList = userThemes.getPageList(selectedTheme)
      let selectedSkin =  userThemes.getSelectedUserSkin(selectedTheme);
      userThemes.setThemeConfig(allThemes,selectedTheme,selectedSkin)

      // 用户角色权限
      let resRole = await rolesByUser();
      let businessManageNav = [];

      if(resRole && resRole.code === 0) {
        let resRoleData = (resRole.data) || [];
        store.commit("SET_USER_ROLE",resRoleData);
        resRoleData.forEach( roleItem => {
          configs.businessManageNav.forEach( item => {
            if(item.code === roleItem) {
              businessManageNav.push(item);
            }
          })
        })
        if(businessManageNav.length > 0) {
          // 测试数据
          pageList.push(  { pageCode: 'BusinessManagementCenter', pageName: '业务管理中心',resourceUrl: ""},)
        }
        store.commit("SET_BUSINESS_MANAGE_NAV",businessManageNav);
      }
      store.commit("SET_USER_NAV",pageList)
      store.commit("SET_USER_WHITE_NAVS",getUserWhiteNavs(pageList))
      store.commit("SET_USER_AUTHED_WHITE_NAVS",getUserAuthedWhiteNavs(pageList))

    }else{
      store.commit("SET_USER_THEME_CONFIG",null);
      store.commit("SET_SYSTEM_STATUS",'Error');
      // Message({
      //   message: res && res.message ,
      //   type: "error"
      // });
    }


}
export default  getRoleAndNavigation
